export interface IAPIResponseMotorVehicleMakes {
  motor_vehicle_makes?: string[];
}

export interface IMotorVehicleMakes {
  motor_vehicle_makes: string[];
}

export interface IMotorVehicleMakeModel {
  make: string;
  name: string;
  year: number;
}

export interface IAPIResponseMotorVehicleModels {
  motor_vehicle_models?: IMotorVehicleMakeModel[];
}

export interface IMotorVehicleModels {
  motor_vehicle_models?: IMotorVehicleMakeModel[];
}

export interface IAPIResponseMotorVehicleVariants {
  motor_vehicles?: IMotorVehicleMakeModelVariant[];
}

export interface IMotorVehicleVariants {
  motor_vehicles?: IMotorVehicleMakeModelVariant[];
}

export interface IMotorVehicleMakeModelVariant {
  id: string;
  model: IMotorVehicleMakeModel;
  variant: string;
  valueNew: number;
  valueRetail: number;
  sum_insured: number;
}

// Motorcycles

export type IAPIResponseMotorCycleMakes = IAPIResponseMotorVehicleMakes

export type IMotorCycleMakes = IMotorVehicleMakes

export type IMotorCycleMakeModel = IMotorVehicleMakeModel

export interface IAPIResponseMotorCycleModels extends IAPIResponseMotorVehicleModels  {
  motor_vehicle_models?: IMotorCycleMakeModel[];
}

export interface IMotorCycleModels extends IMotorVehicleModels {
  motor_vehicle_models?: IMotorCycleMakeModel[];
}

export interface IAPIResponseMotorCycleVariants extends IAPIResponseMotorVehicleVariants {
  motor_vehicles?: IMotorCycleMakeModelVariant[];
}

export interface IMotorCycleVariants extends IMotorVehicleVariants{
  motor_vehicles: IMotorCycleMakeModelVariant[];
}

export interface IMotorCycleMakeModelVariant extends IMotorVehicleMakeModelVariant{ 
  model: IMotorCycleMakeModel;
}
